import React from "react";
import { useForm } from "react-hook-form";
import { useEffect } from "react";
import { styled } from "@mui/material/styles";
import {
  TextField,
  Button,
  Checkbox,
  FormControlLabel,
  Box,
} from "@mui/material";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import FilterAltOffIcon from "@mui/icons-material/FilterAltOff";
import RecordHandlingGrid from "../../Components/RecordHandlingGrid/RecordHandlingGrid";
import "./RecordsHandlingPage.css";
import { useDispatch, useSelector } from "react-redux";
import { fetchFilteredRecords } from "./recordsHandlingSlice";
import { updateAuthorized } from "../../../DataExtractionTool/Authentication/authenticationSlice";
import { useNavigate } from "react-router";

const FiltersSection = styled(Box)(({ theme }) => ({
  display: "flex",
  flexWrap: "wrap",
  gap: "10px",
  backgroundColor: "#f9f9f9",
  padding: "8px",
  borderRadius: "8px",
  boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
  justifyContent: "space-between",
  alignItems: "center",
  [theme.breakpoints.down("sm")]: {
    flexDirection: "column",
    gap: "12px",
  },
}));

const RecordsHandlingPage = () => {
  const { register, handleSubmit, reset, setValue, watch } = useForm({
    defaultValues: {
      oneKeyId: null,
      ahpraId: null,
      firstName: null,
      lastName: null,
      jobId: null,
      awaitingApproval: false,
    },
  });
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { isAuthorised } = useSelector((state) => state.authentication);
  const { isSessionValid } = useSelector((state) => state.recordsHandling);

  useEffect(() => {
    if (!isAuthorised) {
      navigate("/");
    }
  }, [isAuthorised]);

  if (!isSessionValid) {
    dispatch(updateAuthorized(false));
  }

  const awaitingApproval = watch("awaitingApproval");

  // Load initial data (last two week's records)
  useEffect(() => {
    dispatch(fetchFilteredRecords({}));
  }, [dispatch]);

  const onApplyFilters = (data) => {
    console.log("Filters Applied:", data);
    dispatch(fetchFilteredRecords(data));
  };

  const onClearFilters = () => {
    reset();
    setValue("awaitingApproval", false);
    console.log("Filters Cleared");
    dispatch(fetchFilteredRecords({}));
  };

  return (
    <div className="records-handling-page">
      <main className="page-content">
        <FiltersSection
          component="form"
          onSubmit={handleSubmit(onApplyFilters)}
        >
          <TextField
            label="OneKey ID"
            {...register("oneKeyId")}
            variant="outlined"
            size="small"
            sx={{ minWidth: 100, maxWidth: 200 }}
          />
          <TextField
            label="AHPRA ID"
            {...register("ahpraId")}
            variant="outlined"
            size="small"
            sx={{ minWidth: 100, maxWidth: 200 }}
          />
          <TextField
            label="First Name"
            {...register("firstName")}
            variant="outlined"
            size="small"
            sx={{ minWidth: 100, maxWidth: 200 }}
          />
          <TextField
            label="Last Name"
            {...register("lastName")}
            variant="outlined"
            size="small"
            sx={{ minWidth: 100, maxWidth: 200 }}
          />
          <TextField
            label="Job ID"
            {...register("jobId", { valueAsNumber: true })}
            variant="outlined"
            size="small"
            sx={{ minWidth: 100, maxWidth: 200 }}
          />
          <FormControlLabel
            control={
              <Checkbox
                {...register("awaitingApproval")}
                checked={awaitingApproval}
                onChange={(e) => setValue("awaitingApproval", e.target.checked)}
                color="primary"
              />
            }
            label="Awaiting Approval"
            sx={{ marginTop: "4px" }}
          />
          <Box
            sx={{
              display: "flex",
              gap: "12px",
              alignItems: "center",
            }}
          >
            <Button
              variant="outlined"
              onClick={onClearFilters}
              type="button"
              sx={{ color: "#2E3B55", borderColor: "#2E3B55" }}
            >
              <FilterAltOffIcon />
              Clear Filters
            </Button>
            <Button
              variant="contained"
              type="submit"
              sx={{ backgroundColor: "#2E3B55", color: "#ffffff" }}
            >
              <FilterAltIcon fontSize="small" /> Apply Filters
            </Button>
          </Box>
        </FiltersSection>
      </main>
      <RecordHandlingGrid />
    </div>
  );
};

export default RecordsHandlingPage;
